import { ReactNode } from "react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "../ui/tooltip";
type TooltipWrapperProps = {
  text: string;
  children: ReactNode;
};
export default function TooltipWrapper({
  text,
  children
}: TooltipWrapperProps) {
  return <TooltipProvider data-sentry-element="TooltipProvider" data-sentry-component="TooltipWrapper" data-sentry-source-file="tooltip-wrapper.tsx">
      <Tooltip data-sentry-element="Tooltip" data-sentry-source-file="tooltip-wrapper.tsx">
        <TooltipTrigger asChild data-sentry-element="TooltipTrigger" data-sentry-source-file="tooltip-wrapper.tsx">{children}</TooltipTrigger>
        <TooltipContent className="rounded-lg" data-sentry-element="TooltipContent" data-sentry-source-file="tooltip-wrapper.tsx">{text}</TooltipContent>
      </Tooltip>
    </TooltipProvider>;
}